export enum Enums {
  ENABLE_STEP_ONE = 'enable Step1',
  ENABLE_STEP_TWO = 'enable Step2',
  ENABLE_STEP_THREE = 'enable Step3',
  ENABLE_BASIC_DETAILS = 'enable basic details',
  ENABLE_EDUCATION_DETAILS = 'enable education details',
  ENABLE_CERTIFICATE_DETAILS = 'enable certificate details',
  ENABLE_INTERNSHIP_DETAILS = 'enable internship details',
  ENABLE_COMPANY_DETAILS = 'enable company details',
  OPEN_TOPBAR_DROPDOWN = 'open topbar dropdown',

  ENABLE_WEB_CAM = 'ENABLE_WEB_CAM',
  ENABLE_MICRO_PHONE = 'ENABLE_MICRO_PHONE',
  ENABLE_START_SCREEN_RECORDER = 'ENABLE_START_SCREEN_RECORDER',
  ENABLE_FULL_SCREEN = 'ENABLE_FULL_SCREEN',
  ENABLE_EXTENSION = 'ENABLE_EXTENSION',
  ENABLE_VIDEO_AFTER_ALLOWING = 'ENABLE_VIDEO_AFTER_ALLOWING',

  DISABLE_SCREEN_SHARE = 'DISABLE_SCREEN_SHARE',
  DISABLE_SCREEN_SHARE_TEXT = 'Screen Share is mandatory, press ok to continue examination',

  DISABLE_FULL_SCREEN = 'DISABLE_FULL_SCREEN',
  DISABLE_FULL_SCREEN_TEXT = 'Your assessment will be auto submitted if you exit full screen',
  DISABLE_AUDIO = 'DISABLE_AUDIO',
  DISABLE_AUDIO_TEXT = 'Audio is mandatory',
  DISABLE_VIDEO = 'DISABLE_VIDEO',
  DISABLE_VIDEO_TEXT = 'Video is mandatory',
  DISABLE_EXTENSION = 'DISABLE_EXTENSION',
  DISABLE_CONNECTION = 'DISABLE_CONNECTION',
  DISABLE_EXTENSION_TEXT = 'Extension is mandatory, press ok to continue examination',
  DISABLE_SCREEN_SHARE_TEXT_NOT_POSSIBLE = 'You cannot stop screen share while taking test.',
  CANCEL_FULL_SCREEN_TEXT = 'You cannot stop full screen while taking test.',
  CANCEL_VIDEO_TEXT = 'You cannot stop video while taking test.',
  CANCEL_AUDIO_TEXT = 'You cannot stop audio while taking test.',

  CANCEL_EXTENSION_TEXT = 'You cannot stop extension while taking test.',
  LOST_INTERNET_CONNECTION_HEADING = 'Connection Lost <br/> <br/> Unable to establish a connection',
  OPEN_UPLOAD_RESUME_DETAILS = 'open upload details',
  // LOST_INTERNET_CONNECTION_TEXT = "Unable to establish a connection",
  OPEN_CONFORM_UPLOAD_RESUME_POPUP = 'open confrom upload resume popup',
  OPEN_POPUP_FOR_PREVIEW_PDF = 'open popup for preview pdf',
  SHOW_TEXT_AS_PER_UPLOAD_RESUME = 'show text as per upload resume',
  LOADER_SKELETON = 'skeleton loader',
  PROFILE_DETAILS_SKELETON = 'Details Skeleton Loader',
  OPEN_CHECKBOXES = 'checkbox open',
  OPEN_RESET_PASSWORD_FORM = 'open reset password form',
  DISABLE_MOBILE_NETWORK_NOT_POSSIBLE = 'Unable to establish a connection from the mobile device.',
  VIEW_ADD_SCHEDULE_DRIVE_FORM = 'view add schedule drive',
  ADD_SCHEDULE_DRIVE_SUCCESS = 'add schedule drive success',
  SHOW_ASSISSMENT_INSTRUCTIONS = 'assessment instructions',
  SHOW_ASSISSMENT_RULES = 'assessment rules',
  SHOW_GROUND_RULE_PAGE_ONE = 'ground rules one',
  SHOW_GROUND_RULE_PAGE_TWO = 'ground rules two',
  COPY_CODE_TEXT = 'code text',
  COPY_MAIL_TEXT = 'mail text',
  COPY_DATE_TEXT = 'date text',
  Reload_Assessment = 'Reload_Assessment',
  Submit_Section = 'Submit_Section',
  MULTIPLE_SCREEN = 'Multiple Monitors detected !',
  PAUSED_MULTIPLE_SCREEN = 'The assessment has been paused due to the detection of multiple monitors. Please ensure you are using only one monitor to continue',
  WARNING_MULTIPLE_SCREEN = 'The assessment cannot be started due to the detection of multiple monitors. Please ensure you are using only one monitor to continue',
  BACKGROUND_APPLICATIONS = 'Following apps detected:',
  PAUSED_BACKGROUND_APPLICATIONS = 'The assessment has been paused due to the detection of active applications. Please ensure they are closed before continue.',
  WARNING_BACKGROUND_APPLICATIONS = 'The assessment cannot be started due to the detection of active applications. Please close them to continue or click Refresh if already closed.',
  EXTERNAL_HARDWARE_TITLE = 'External hardware detected:',
  PAUSED_EXTERNAL_HARDWARE = 'The assessment has been paused due to the detection of external hardware device. Please ensure no external hardware device is detected.',
  EXTRENAL_HARDWARE_WARNING = 'The assessment cannot be started due to the detection of external hardware device. Please ensure no external hardware device is detected.',


  // Enums of questionTypes
  JUPYTER_NOTEBOOK = 'JUPYTER_NOTEBOOK',
  CODING_SKILLS = 'CODING_SKILLS',
  IDE = 'APPLICATION_DEVELOPMENT',
  INTERVIEW_BOT_RESPONSE = 'INTERVIEW_BOT_RESPONSE',
  MULTIPLE_CHOICE_QUESTIONS = 'MULTIPLE_CHOICE_QUESTIONS',
  APPLICATION_DEVELOPMENT = 'APPLICATION_DEVELOPMENT',
  FIB_QUESTIONS = 'FIB_QUESTIONS',
  CASE_STUDY = 'CASE_STUDY',
  BIG_QUERY_CODING = 'BIGQUERY_QUESTIONS',
  VIDEO_ESSAY_EVALUATION = 'Video Evaluation',


  // Enums for title
  BRAND_NAME='iqigai'
}
